import type { FaireProductEntity } from "../../entity_types/product";

export const p_md94cgyfp4: FaireProductEntity = {
  token: "p_md94cgyfp4",
  type: "product",
  name: "Woon Dried Shiitake Mushrooms",
  brandToken: "b_th428x9zzy",
  brandName: "Woon",
  imageUrl: "https://cdn.faire.com/fastly/0dc84fb8e874579a1482b7fc6a8d25fa6ff86ea24205c743134af7286e4b66c8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e6e36bc12bde85aaa1b1e56df544b76493e413e2f8bd234b30c7384016bb06b3.jpeg",
    "https://cdn.faire.com/fastly/905373d45e086694fb8aa89c5f59e46b1cf4d5b9acb63abaf5d09d39bb0d3130.jpeg",
    "https://cdn.faire.com/fastly/cec9af0fd7c230b6a950ec8d693ebf13e8cbb2e2ca2ad2d5094e19fa5ed70aa2.jpeg",
    "https://cdn.faire.com/fastly/6d7c6c60d6ad3641d8f171e8a3b3156a5e3c32ab08e46449553623672a1dbf4e.jpeg"
  ],
  priceDollars: 6.4,
  description: "A pantry must-have! Dried shiitake mushrooms last for a long time and are quick and easy to use. Mama Fong always had these on hand to add umami to any dish at any given moment. Slice or use whole, stir fry with veggies, noodles, or rice, add to soups, or even save the leftover soaking water to use as a broth for some extra umami.\n\n𝐈𝐧𝐬𝐭𝐫𝐮𝐜𝐭𝐢𝐨𝐧𝐬:\nSoak in boiling water for 10 - 20 minutes. Drain. Discard the stems and slice to add to stir-fries, soups, curries and even pasta. Pro tip: save the soaking water in the fridge to use later as a broth or to cook rice for some extra umami.",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:02.065Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
